import dayjs from '../plugins/dayjs';
// eslint-disable-next-line import/prefer-default-export
export const csvReport = {
  data: () => ({
    reportData: {},
    reportDisputeGenerationObject: {
      startDisputeDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endDisputeDate: dayjs().subtract(1, 'month').endOf('month').format(),
      sort: '-disputeDate',
    },
    reportRefundGenerationObject: {
      startRefundDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endRefundDate: dayjs().subtract(1, 'month').endOf('month').format(),
      sort: '-refundDate',
    },
    reportCaptureGenerationObject: {
      startCaptureDate: dayjs().subtract(1, 'month').startOf('month').format(),
      endCaptureDate: dayjs().subtract(1, 'month').endOf('month').format(),
      sort: '-captureDate',
    },
    reportPayoutGenerationObject: {
      statusAtStart: dayjs().subtract(1, 'month').startOf('month').format(),
      statusAtEnd: dayjs().subtract(1, 'month').endOf('month').format(),
      status: 'paid',
      sort: '-captureDate',
    },
    reportGenerating: false,
  }),
  watch: {
    reportData() {
      this.reportGenerating = false;
    },
  },
  methods: {
    async generateDisputeReport() {
      this.reportGenerating = true;
      this.reportData = await this.$store.dispatch('csvReport/generateDisputeReport', this.reportDisputeGenerationObject);
      this.reportGenerating = false;

      return this.reportData;
    },

    async generateRefundReport() {
      this.reportGenerating = true;
      this.reportData = await this.$store.dispatch('csvReport/generateRefundReport', this.reportRefundGenerationObject);
      this.reportGenerating = false;

      return this.reportData;
    },

    async generateCaptureReport() {
      this.reportGenerating = true;
      this.reportData = await this.$store.dispatch('csvReport/generateCaptureReport', this.reportCaptureGenerationObject);
      this.reportGenerating = false;

      return this.reportData;
    },

    async generatePayoutReport() {
      this.reportGenerating = true;
      this.reportData = await this.$store.dispatch('csvReport/generatePayoutReport', this.reportPayoutGenerationObject);
      this.reportGenerating = false;

      return this.reportData;
    },
  },
};
